<div class="mx-8 my-20" animate.enter="ease-in-fast" *transloco="let t">
  <div class="flex items-center justify-between">
    <div>
      <h1 class="text-3xl font-semibold">
        {{ t('portal.team.headline') }}
      </h1>
      <h1 class="text-base text-grey">
        {{ t('portal.team.subtitle') }}
      </h1>
    </div>
  </div>

  <div class="mt-10">
    <app-user-management-overview />
  </div>
  <router-outlet />
</div>
